/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, ButtonBase, Card, CircularProgress, Container, Dialog, FormControl, FormHelperText, InputBase, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "app/hooks";
import React, { Fragment, useEffect, useState } from "react";
import { popupSelector, setUpdate } from "components/Popup/popupSlice";
import { userSelector } from "components/user/userSlice";
import { GasFeeInterface } from "types";
import ApiSingWallet from "libs/apiSingWallet";
import fernet from 'fernet';
import { FERNET_KEY } from "libs/constans";

type IProps = {
    onClose: () => void;
    token: any;
}
const btn_styles = {
    width: '100%',
    background: '#33394F',
    boxShadow: `0px 4px 15px rgba(0, 0, 0, 0.5)`,
    borderRadius: '24px',
    padding: '14px 24px',
    display: 'flex',
    justifyContent: 'center',
    alignTtems: 'center',
} as const;

const btn_styles2 = {
    width: '100%',
    background: `linear-gradient(90deg, #BF26E6 -5.41%, #3C14DA 100%)`,
    boxShadow: `0px 4px 15px rgba(0, 0, 0, 0.5)`,
    borderRadius: '24px',
    padding: '14px 24px',
    display: 'flex',
    justifyContent: 'center',
    alignTtems: 'center',
} as const;

export default function SendNft(props: IProps) {
    const { onClose, token } = props;
    const dispatch = useAppDispatch();
    const [error, setError] = useState(" ");
    const api = new ApiSingWallet();

    const [address, setAddress] = useState('');
    const { wallet } = useAppSelector(popupSelector);
    const { user, tokenBearer } = useAppSelector(userSelector);

    const [pending, setPending] = useState(false);
    const [gasFee, setGasFee] = useState<GasFeeInterface>()

    const [isLoading, setLoading] = useState(false);
    const [open, setOpen] = useState(false)

    const handleAddressChange = (e: any) => {
        setAddress(e.target.value)
    }

    const getGasFee = async (price, walletId) => {
        setPending(true);
        await api.getGasFee(price, walletId, tokenBearer).then(
            (result) => {
                setGasFee(result)
            },
            (error) => {
                console.log(error!.message)
                setError(error!.message)
            }
        )
        setPending(false);
    }

    useEffect(() => {
        if (!pending && wallet) {
            getGasFee(1, wallet.id)
        }
    }, [user, wallet])

    const handleClose = () => {
        onClose();
    }

    const handleClick = async () => {
        setLoading(true)
        var tk = {
            token_contract: token.token_address ? token.token_address : "",
            token_id: token.token_id,
            receiver_address: address,
        }
        var secret = new fernet.Secret(FERNET_KEY);
        var encrypted = new fernet.Token({
            secret: secret,
        })
        encrypted.encode(JSON.stringify(tk));

        await api.sendNft(wallet?.id, encrypted.token, tokenBearer).then(
            (result) => {
                console.log(result);
                setError(" ");
                dispatch(setUpdate());
                setOpen(true)
            },
            (error) => {
                console.log(error!.message)
                setError(error!.message)
            }
        )

        setLoading(false)
    }

    return (
        <Fragment>
            <Box>
                <Box p={1} sx={{ mb: 2 }}>
                    <Typography sx={{ mb: 1, color: '#ffffff' }}>Receiver Address</Typography>
                    <FormControl fullWidth variant="outlined">
                        <InputBase
                            value={address}
                            onChange={handleAddressChange}
                            sx={{
                                borderRadius: '8px',
                                border: 'solid 1px #413D3D',
                                p: 1,
                                background: '#20273F',
                            }}

                        />
                    </FormControl>
                </Box>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, mt: 1 }}>
                <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>{`Network Fee *`}</Typography>
                <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>{pending ? `loading...` : `${gasFee ? gasFee.gas_fee_native.toFixed(6) : 0}${gasFee?.native_symbol || ' BNB'} ≈ $${gasFee ? gasFee.gas_fee_usd.toFixed(6) : 0}`}</Typography>
            </Box>
            <Box p={2}>
                <FormHelperText sx={{ color: '#B1BBD2' }}>{error}</FormHelperText>
            </Box>
            <Box sx={{ width: '100%', pb: 2 }}>
                <Container fixed maxWidth='sm'>
                    <Box sx={{ mx: 1 }}>
                        <ButtonBase
                            sx={address ? btn_styles2 : btn_styles}
                            onClick={handleClick}
                            disabled={isLoading || pending || !address}
                        >
                            {(isLoading || pending)? <CircularProgress size={20} /> : `CONFIRM`}
                        </ButtonBase>
                    </Box>
                </Container>
            </Box>
            <Dialog open={open}>
                <Card>
                    <Box p={2}>
                        <Typography>Transaction success</Typography>
                    </Box>
                    <Box m={2} sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Button onClick={handleClose} variant="contained">Back</Button>
                    </Box>
                </Card>
            </Dialog>
        </Fragment>
    );
}